import * as Api from '@ViewModels';
import { findRaisedRegEdRound } from './types';

/** Why the officer wasn't sent the open round's review link; undefined once one went out. */
export const getRegEdOfficerNotificationFailure = (
	approvalRequests: Api.ICampaignApprovalRequest[] | null | undefined
): Api.OfficerNotificationFailure | undefined =>
	findRaisedRegEdRound(approvalRequests)?.officerNotificationFailure ?? undefined;
